import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Circle,
  InfoWindow
} from "react-google-maps";

const AllZonesMap = props => {
  const {
    places,
    handleEndNow
  } = props;
  const [selectedPlace, setSelectedPlace] = useState(false);

  return (
    <GoogleMap
      defaultZoom={12}
      defaultCenter={{
        lat: 40.15,
        lng: 44.51
      }}
    >
      {places.map((place, index) => (
        <Fragment key={place.id}>
          <Marker
            position={{
              lat: parseFloat(place.latitude),
              lng: parseFloat(place.longitude)
            }}
            label={index.toString()}
            onClick={() => setSelectedPlace(place)}
          />
          {place.circle && (
            <Circle
              defaultCenter={{
                lat: parseFloat(place.latitude),
                lng: parseFloat(place.longitude)
              }}
              radius={place.circle.radius}
              options={place.circle.options}
            />
          )}
        </Fragment>
      ))}

      {selectedPlace ?
        <InfoWindow
          onCloseClick={() => setSelectedPlace(false)}
          position={{
            lat: parseFloat(selectedPlace.latitude),
            lng: parseFloat(selectedPlace.longitude)
          }}
        >
          <div>
            <h5>{selectedPlace.title} (Bonus: {selectedPlace.bonus})</h5>
            <div>{selectedPlace.description}</div>
            <div className="mt-2">
              <button
                className="btn btn-outline-danger btn-sm btn-block"
                onClick={() => {
                  setSelectedPlace(false);
                  handleEndNow(selectedPlace);
                }}
              >
                End now
              </button>
            </div>
          </div>
        </InfoWindow>
        : null}
    </GoogleMap>
  );
};

AllZonesMap.propTypes = {
  places: PropTypes.array,
  handleEndNow: PropTypes.func.isRequired
};

export default withScriptjs(withGoogleMap(AllZonesMap));



// WEBPACK FOOTER //
// ./src/views/pages/zoning/all-zones-map.js